import { RouteConfig } from 'vue-router';
import Form from '@/views/layout/Form.vue';
import i18n from '@/i18n';

const routes: Array<RouteConfig> = [
  {
    path: 'languageCapability',
    name: 'languageCapability',
    component: Form,
    redirect: { name: 'languageCapability-list' },
    meta: {
      session: true,
    },
    children: [
      {
        path: 'list',
        name: 'languageCapability-list',
        component: () =>
          import('@/views/languageCapability/LanguageCapabilityList.vue'),
        meta: {
          header: {
            label: () => i18n.tc('languageCapability.label', 2),
          },
        },
      },
      {
        path: 'create',
        name: 'languageCapability-create',
        component: () =>
          import('@/views/languageCapability/LanguageCapabilityCreate.vue'),
        meta: {
          header: {
            route: { name: 'languageCapability-list' },
            label: () =>
              i18n.t('title.create', [i18n.tc('languageCapability.label', 2)]),
          },
        },
      },
      {
        path: 'edit/:id',
        name: 'languageCapability-edit',
        component: () =>
          import('@/views/languageCapability/LanguageCapabilityEdit.vue'),
        meta: {
          header: {
            route: { name: 'languageCapability-list' },
            label: () =>
              i18n.t('title.edit', [i18n.tc('languageCapability.label', 2)]),
          },
        },
      },
    ],
  },
];

export default routes;
